import React, { Suspense, lazy } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useQuery } from "@apollo/react-hooks";
import ReactGA from "react-ga4";
import { Router, createHistory, LocationProvider } from "@reach/router";

import SideNav from "./components/Navigation/SideNav";
import TopNav from "./components/Navigation/TopNav";
import ActivityLoader from "./components/ActivityLoader";
import Footer from "./components/Navigation/Footer";
import { GET_CATEGORIES_SIDE_MENU } from "./QUERY/QUERY/category";
// import SocialAuth from './components/Auth/SocialAuth';
import NotFound from "./components/Pages/NotFound";
import Epaper from "./components/Pages/Epaper";

const Post = lazy(() => import("./components/Pages/Post"));
const Category = lazy(() => import("./components/Pages/Category"));
const Home = lazy(() => import("./components/Pages/Home"));
const User = lazy(() => import("./components/Pages/User"));
const EpaperList = lazy(() => import("./components/Pages/EpaperList"));

const history = createHistory(window);

ReactGA.initialize("G-4BTRBZS6ML");

if (process.env.NODE_ENV === "production") {
  ReactGA.send({
    hitType: "pageview",
    page: window.location.pathname,
    title: window.document.title,
  });
}

history.listen(({ action }) => {
  if (process.env.NODE_ENV === "production") {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: window.document.title,
    });
  }

  if (action !== "POP") {
    window.scrollTo(0, 0);
  }
});

const RootDOM = ({ sideNavVisibility }) => {
  const {
    data: sideNavCategoryData,
    loading: sideNavLoading,
    error: sideNavFetchError,
  } = useQuery(GET_CATEGORIES_SIDE_MENU);

  if (sideNavFetchError) {
    throw new Error("Error Occurred");
  }

  return (
    <AppWrapper>
      <LocationProvider history={history}>
        {/* <SocialAuth /> */}
        <TopNav sideNavVisibility={sideNavVisibility} />
        <SideNav
          sideNavCategoryData={sideNavCategoryData}
          sideNavLoading={sideNavLoading}
        />
        <RoutesWrapper
          animate={sideNavVisibility ? "pushToRight" : "default"}
          variants={{ pushToRight: { x: 200 }, default: { x: 0 } }}
        >
          <Suspense fallback={<ActivityLoader />}>
            <Router>
              <Home path="/" />
              <Category path="/:type/:slug" />
              <Category path="/:type/:subType/:slug" />
              <Post path="/:catSlug/:year/:month/:date/:postSlug" />
              <User path="/user/:username" />
              <EpaperList path="/epapers" />
              <Epaper path="/epapers/:id" />
              <NotFound default />
            </Router>
          </Suspense>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "3rem 0",
            }}
          >
            <iframe
              title="Like Page"
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fyougbodh%2F&tabs&width=340&height=214&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=298503144230467"
              width="340"
              height="214"
              style={{ border: "none", overflow: "hidden" }}
              scrolling="no"
              frameborder="0"
              allowTransparency="true"
              allow="encrypted-media"
            ></iframe>
          </div>
          <Footer
            sideNavCategoryData={sideNavCategoryData}
            sideNavLoading={sideNavLoading}
          />
        </RoutesWrapper>
      </LocationProvider>
    </AppWrapper>
  );
};

const AppWrapper = styled.div`
  font-size: 1.5rem;
`;

const RoutesWrapper = styled(motion.div)`
  min-height: 80vh;
`;

export default RootDOM;
